var _style, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 249.3 113.4",
    style: {
      enableBackground: "new 0 0 249.3 113.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#1D1D1B;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:url(#SVGID_2_);}\n\t.st4{fill:url(#SVGID_3_);}\n\t.st5{fill:url(#SVGID_4_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.1501,
    y1: 84.9116,
    x2: 38.1501,
    y2: 22.0279
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0000B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00909091,
    style: {
      stopColor: "#0000B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000050"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M46.4,24.6c-0.7-0.1-1.3-0.1-2-0.1c-4.9,0-9.7,2-14,5.8c-2,1.8-3.9,4-5.6,6.4c-0.3-9.3-0.8-19.2-1.8-29.3H10.5 c2.7,28.4,2.4,53.2,1.9,75h0c0,0,0,0.1,0,0.1h12.5c0.4-21.8,5.8-35.8,13.9-43c2.2-1.9,4.3-2.8,6.2-2.6c9.9,1.1,8.3,31.9,7.6,45.6 h12.5c0.5-10.1,1.1-22.4-0.3-33C62.8,34,56.5,25.7,46.4,24.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 158.5772,
    y1: 84.9116,
    x2: 158.5772,
    y2: 22.0279
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0000B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00909091,
    style: {
      stopColor: "#0000B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000050"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M174.2,26.5c-3-1.4-6.2-2.1-9.4-2.1c-3.3,0-6.6,0.7-9.9,2.2c-9,4.1-16.5,13.5-20,25.2c-5.4,18-5.1,39.6-5,53.9 c0,0.4,0,0.7,0,1.1h12.5c0-0.4,0-0.8,0-1.2c-0.1-13.5-0.4-34,4.5-50.2c2.4-8.2,7.5-14.8,13.2-17.4c3.1-1.4,6.1-1.4,8.8-0.2 c2.9,1.4,4.4,4.3,5,6.6c1.6,5.2,0.8,11.5-2.1,16c-4.5,7.3-10.7,9.9-22.1,9.6l0,12.4c12,0.1,25.1-2.7,32.8-15.5 c4.6-7.6,6-17.6,3.4-26.2C184,34.2,179.8,29.1,174.2,26.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.3556,
    y1: 84.9116,
    x2: 99.3556,
    y2: 22.0279
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0000B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00909091,
    style: {
      stopColor: "#0000B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000050"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M99.4,24.1c-16.1,0-29.1,13.4-29.1,29.9c0,16.5,13.1,29.9,29.1,29.9c16.1,0,29.1-13.4,29.1-29.9 C128.5,37.5,115.4,24.1,99.4,24.1z M99.4,71.4c-9.2,0-16.6-7.8-16.6-17.4c0-9.6,7.4-17.4,16.6-17.4c9.2,0,16.6,7.8,16.6,17.4 C116,63.6,108.5,71.4,99.4,71.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 215.3602,
    y1: 84.9116,
    x2: 215.3602,
    y2: 22.0279
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0000B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00909091,
    style: {
      stopColor: "#0000B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000050"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M220.5,24.1c-4.6,0-8.8,1.7-12.5,5.1c-1.4,1.3-2.7,2.8-3.9,4.4c-0.3-2.6-0.6-5.3-0.9-8.1h-12.6 c3,22.3,2.7,40.7,2.5,52c0,1.7-0.1,3.2-0.1,4.5c0,0.1,0,0.2,0,0.4h0h12.5c0.1-8.4,0.4-15.1,2.3-25.3C209.7,47,215.3,36,221,36.6 c4.5,0.4,6,5.8,6.5,10.8h12.6C239.4,32.4,230.9,24.1,220.5,24.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f80346f9f181ef771cbea91989c06e61.svg";
export { ForwardRef as ReactComponent };